{
  "version": 1,
  "asset_id": "e8542689-0c47-43f9-81ae-1d2b588ed75c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e8542689-0c47-43f9-81ae-1d2b588ed75c/hiatal-type-3-v2-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e8542689-0c47-43f9-81ae-1d2b588ed75c/hiatal-type-3-v2-800.jpg",
  "original_filename": "hiatal-type-3-v2-800.jpg",
  "size": 78368,
  "content_type": "image/jpeg",
  "created_at": "2026-09-24T19:27:51Z"
}
